module.exports = __webpack_public_path__ + "static/media/add_new_product_excel.1c5239c0.png";